module.exports = __webpack_public_path__ + "static/img/img2.7c2c06d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scenariusze/img/img2.png
// module id = +30F
// module chunks = 0